// extracted by mini-css-extract-plugin
export var folderLabel = "un2IX";
export var postedToLabel = "Kw_BX";